module.exports = __webpack_public_path__ + "static/complex_scroll_1-adc4dc765ef9b6a9226b648024b5b1cf.png";